// extracted by mini-css-extract-plugin
module.exports = {"containerfooter":"footer_containerfooter__2h3fP","nodeco":"footer_nodeco__3lEFU","nodecoactive":"footer_nodecoactive__2xtKH","child":"footer_child__2fqC8"};